import axios from "axios";

export const collectionColumnService = {
  getCollectionColumnsByTableName
};

function getCollectionColumnsByTableName(tableName) {
  return axios.get(`${process.env.VUE_APP_API_URL}/collectionColumn/${tableName}`);
}